import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=eaa20dc2"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaa20dc2')) {
      api.createRecord('eaa20dc2', component.options)
    } else {
      api.reload('eaa20dc2', component.options)
    }
    module.hot.accept("./Preferences.vue?vue&type=template&id=eaa20dc2", function () {
      api.rerender('eaa20dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/Preferences.vue"
export default component.exports